import { openModal } from "../../../AddToCart/ModalSevice";
import { AddToWishlistWizard, type AddToWishlistWizardProps } from "./AddToWishlistWizard";

export function openAddToWishlistWizard(props: Omit<AddToWishlistWizardProps, "closePopup">) {
  return openModal("add-to-wishlist-modal", (close) => <AddToWishlistWizard closePopup={close} {...props} />);
}
